import React from "react";

const Loader: React.FC = () => {
  return (
    <div className="loader">
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
      <div className="wave" />
    </div>
  );
};

export default Loader;
